// extracted by mini-css-extract-plugin
module.exports = {"container":"user-location_container__1PF-B","lastLocation":"user-location_lastLocation__erjXV"};